<template>
	<div class="icon-payment">
		<svg
			style="color: rgb(188, 192, 207)"
			width="24.000000"
			height="24.000000"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
		>
			<desc>Created with Pixso.</desc>
			<defs>
				<clipPath id="clip85_2199">
					<rect
						id="search"
						width="24.000000"
						height="24.000000"
						fill="white"
						fill-opacity="0"
					/>
				</clipPath>
			</defs>
			<g clip-path="url(#clip85_2199)">
				<path
					id="Слияние"
					d="M8.86621 20.75L17 20.75C20.6499 20.75 22.75 18.6499 22.75 15L22.75 9C22.75 5.3501 20.6499 3.25 17 3.25L7 3.25C3.3501 3.25 1.25 5.3501 1.25 9L1.25 15.0869C0.623535 15.8918 0.25 16.9028 0.25 18C0.25 18.8701 0.48999 19.72 0.939941 20.4399C1.78003 21.8701 3.34009 22.75 5 22.75C6.53979 22.75 7.99341 21.9929 8.86621 20.75ZM9.5813 19.25L17 19.25C19.8601 19.25 21.25 17.8601 21.25 15L21.25 9C21.25 6.13989 19.8601 4.75 17 4.75L7 4.75C4.13989 4.75 2.75 6.13989 2.75 9L2.75 13.8171C3.41992 13.4553 4.18628 13.25 5 13.25C7.62012 13.25 9.75 15.3799 9.75 18C9.75 18.4253 9.69263 18.8459 9.5813 19.25ZM12 15.25C10.21 15.25 8.75 13.79 8.75 12C8.75 10.21 10.21 8.75 12 8.75C13.79 8.75 15.25 10.21 15.25 12C15.25 13.79 13.79 15.25 12 15.25ZM17.75 14.5C17.75 14.9099 18.0901 15.25 18.5 15.25C18.9099 15.25 19.25 14.9099 19.25 14.5L19.25 9.5C19.25 9.09009 18.9099 8.75 18.5 8.75C18.0901 8.75 17.75 9.09009 17.75 9.5L17.75 14.5ZM12 10.25C11.04 10.25 10.25 11.04 10.25 12C10.25 12.96 11.04 13.75 12 13.75C12.96 13.75 13.75 12.96 13.75 12C13.75 11.04 12.96 10.25 12 10.25ZM5 14.75C3.20996 14.75 1.75 16.21 1.75 18C1.75 18.5901 1.90991 19.1699 2.21997 19.6699C2.80005 20.6499 3.87012 21.25 5 21.25C6.12988 21.25 7.19995 20.6499 7.78003 19.6799C8.09009 19.1699 8.25 18.6001 8.25 18C8.25 16.21 6.79004 14.75 5 14.75ZM5 20.26C4.59009 20.26 4.25 19.9199 4.25 19.51L4.25 18.73L3.50977 18.73C3.09985 18.73 2.75977 18.3899 2.75977 17.98C2.75977 17.5701 3.09985 17.23 3.50977 17.23L4.25 17.23L4.25 16.52C4.25 16.1099 4.59009 15.77 5 15.77C5.40991 15.77 5.75 16.1099 5.75 16.52L5.75 17.23L6.49976 17.23C6.90967 17.23 7.24976 17.5701 7.24976 17.98C7.24976 18.3899 6.90967 18.73 6.49976 18.73L5.75 18.73L5.75 19.51C5.75 19.9299 5.40991 20.26 5 20.26Z"
					clip-rule="evenodd"
					:fill="isHover ? 'var(--theme-color)' : color"
					fill-opacity="1.000000"
					fill-rule="evenodd"
				/>
			</g>
		</svg>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
	props: {
		isHover: { type: Boolean, default: false },
		color: { type: String, default: "rgb(188, 192, 207)" },
	},
})
export default class IconPayment extends Vue {}
</script>

<style scoped lang="scss">
.icon-payment {
	display: flex;
}
</style>
